module.exports = __webpack_public_path__ + "static/media/shakeshack.9bc5d28e.png";